import Vuex from 'vuex'

import { currentUser } from './modules/currentUser'
import { docusignToken } from './modules/docusignToken'
import { language } from './modules/language'

export default new Vuex.Store({
  modules: {
    currentUser,
    docusignToken,
    language
  }
})